import type {
  InvitationLinkFormProps,
  InvitationLinkUpdateProps,
  InvitationLinkValues,
} from "@circle-react/components/SettingsApp/InvitationLinks/interfaces";
import {
  reactQueryDelete,
  reactQueryGet,
  reactQueryPatch,
  reactQueryPost,
  reactQueryPut,
} from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";

interface ParamsProps {
  params?: Record<string, unknown>;
}

interface IdProps {
  id: string;
}

const list = ({ params = {} }: ParamsProps) =>
  reactQueryGet(internalApi.invitationLinks.index({ params }));

const get = ({ id }: IdProps) =>
  reactQueryGet<any>(internalApi.invitationLinks.get({ id }));

const create = ({
  invitationLink,
  paywall,
  accessGroups,
}: InvitationLinkValues) =>
  reactQueryPost(internalApi.invitationLinks.create(), {
    invitation_link: invitationLink,
    paywall: paywall,
    access_groups: accessGroups["access_groups"],
  });

const update = ({
  id,
  invitationLink,
  paywall,
  accessGroups,
}: InvitationLinkUpdateProps) =>
  reactQueryPut<InvitationLinkFormProps, any>(
    internalApi.invitationLinks.update({ id }),
    {
      invitation_link: invitationLink,
      paywall: paywall,
      access_groups: accessGroups["access_groups"],
    },
  );

const revoke = ({ id }: IdProps) =>
  reactQueryPatch(internalApi.invitationLinks.revoke({ id }));

const reactivate = ({ id }: IdProps) =>
  reactQueryPatch(internalApi.invitationLinks.reactivate({ id }));

const destroy = ({ id }: IdProps) =>
  reactQueryDelete(internalApi.invitationLinks.destroy({ id }));

export const invitationLinksApi = {
  list,
  get,
  create,
  update,
  revoke,
  reactivate,
  destroy,
};
